.indicators {
  display: flex;
  align-items: center;
  margin-top: var(--spacingLg);

  .negative {
    color: var(--paletteRed0);
  }

  > span {
    flex-basis: 50%;
  }
}
